import { Loadable } from 'foundations-components/transitional/utils/Loadable';
// @ts-expect-error Untyped import
import SimpleReportsListHeader from './SimpleReportsListHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const loader = () =>
// @ts-expect-error Untyped import
import( /* webpackChunkName: "ReportsListHeader" */'./ReportsListHeader');
export default Loadable({
  loader,
  LoadingComponent: () => /*#__PURE__*/_jsx(SimpleReportsListHeader, {})
});